import '../CameraUploadButton/CameraUploadButton.css';

import React from 'react';

export interface VideoUploadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}

const VideoUploadButton: React.FC<VideoUploadButtonProps> = ({
  onClick,
  disabled = false,
  ariaLabel = 'Record video',
  className = '',
}) => (
  <button
    type="button"
    className={['camera-upload-button', className].filter(Boolean).join(' ')}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    <svg
      className="camera-upload-button-icon"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="2"
        y="6"
        width="14"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16 10l5-3v10l-5-3V10z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  </button>
);

export default VideoUploadButton;
